module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABEBAMAAADjOnEGAAAAG1BMVEW8vLwAAAAXFxcvLy9eXl6NjY1GRkakpKR1dXXcPLm2AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAq0lEQVQ4je2QsQ6CMBRFr8VSR0sidTQEI2MxuJdBWYX4ByTMQML+Fv/bEhv5AQdjesZ77k1eHuDx/CNMl1JedhiJn0nk2UeUGgioRYu6AjN173KeWtGAXRUKYNUzciJ4WFGARwZxYoJlcVtr8AOQQ8RTJuTe5eJkRWiwiYzYomPU3N8ilFJi6DE+FRS6ei457KID5qva6ThQQ4sQClxhNGFCPE+//ymP55d5AW2nGNfFmsm2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon04.png
// module id = NdzI
// module chunks = 0